import { cva, type VariantProps } from "cva";

import styles from "./index.module.css";

export const variants = cva({
  base: styles.base,
  variants: {
    align: {
      left: styles.left,
      center: styles.center,
      right: styles.right,
    },
    radius: {
      none: styles.radiusNone,
    },
    width: {
      full: styles.full,
      fit: styles.fit,
    },
  },
  defaultVariants: {
    align: "center",
    width: "full",
  },
});

export type SubtleButtonVariantProps = VariantProps<typeof variants>;
